import CustomerQuotesHtml from './customer.quotes.html'

export function CustomerQuotesDirective () {
  return {
    controller: 'CustomerQuotesCtrl',
    restrict: 'E',
    templateUrl: CustomerQuotesHtml,
    scope: {
      customer: '=',
      quotes: '='
    }
  }
}